import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { portraitFor } from "@/constants/images";

// Renders a child photo: if photo_path exists on the child, fetch it as a blob
// via the authenticated /api/files endpoint. Falls back to a deterministic portrait.
export default function ChildPhoto({ child, className = "w-16 h-16 rounded-2xl object-cover ring-4 ring-white shadow-md", alt }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let url = null;
    (async () => {
      if (!child?.photo_path) {
        setSrc(portraitFor(child?.id));
        return;
      }
      try {
        const res = await api.get(`/files/${child.photo_path}`, { responseType: "blob" });
        if (cancelled) return;
        url = URL.createObjectURL(res.data);
        setSrc(url);
      } catch (_) {
        if (!cancelled) setSrc(portraitFor(child?.id));
      }
    })();
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [child?.id, child?.photo_path]);

  return <img src={src || portraitFor(child?.id)} alt={alt || child?.name || ""} className={className} />;
}
